module.exports = {
  IMPC: 'IMPC',
  OPERATOR: 'OPERATOR',
};
